import React, { useState, useRef, useEffect } from "react"; //forwardRef,
import makeStyles from '@mui/styles/makeStyles';
import swal from "sweetalert";
// materialui table
import MaterialTable from "@material-table/core";

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";

import {
  Typography,
  TextField,
  Grid,
  Card,
  CardContent,
  FormControl,
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';



//import ReactExport from "react-data-export";
import { useTranslation } from "react-i18next";

//import XLSX from "xlsx";
//import FileSaver from "file-saver";
import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";
//import OrderModal from "./OrderModal";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { fr, enGB } from "date-fns/locale"; // import French and English locale

import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { getFacilityListByGroup } from "../../../services/Common";
import encryptionService from "../../../services/encryptionService";

import { format, subDays } from 'date-fns';
const ReceiveInv = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "dispense";
  const FacilityId = localStorage.getItem("FacilityId");
  const FacilityName = localStorage.getItem("FacilityName");


  /*   const [openOrder, setOpenOrder] = useState(false); */

  const classes = useStyles();
  const tableRef = useRef();

  const [selectedRow, setSelectedRow] = useState(null);
  const [productsData, selectProductsData] = useState([]);
  const [productsAllData, selectProductsAllData] = useState([]);
  const [productGroupData, selectProductGroupData] = useState([]);
  const [productGroupFilter, selectProductGroupFilter] = useState("0");
  const [firstLoad, setFirstLoad] = useState(true);
  const [numberRowPerPage, setNumberRowPerPage] = useState(5);
  const [totalRow, setTotalRow] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [dataItems, setDataItems] = useState([]);
  //const [query, setQuery] = useState("");

  const UserInfo = encryptionService.decryptUserInfo();
  const userId = UserInfo == 0 ? "" : UserInfo[0].id;

  const DefaultFacilityId = localStorage.getItem("DefaultFacilityId");
  const IsAllFacility = UserInfo == 0 ? "" : UserInfo[0].IsAllFacility;

  const assignedProdGroupList = UserInfo[0].ItemGroupId.split(",");
  const [prodGroupCountUnderRole, setProdGroupCountUnderRole] = React.useState(assignedProdGroupList.length);
  const RoleItemGroupId = UserInfo == 0 ? "" : assignedProdGroupList[0];
 /*  const RoleItemGroupId = UserInfo == 0 ? "" : UserInfo[0].ItemGroupId; */

  const ProductGroupList = JSON.parse(localStorage.getItem("ProductGroupList"));
  //const [currProductGroupId, setCurrProductGroupId] = useState(ProductGroupList[0].id);
  const [currProductGroupId, setCurrProductGroupId] = useState(RoleItemGroupId);

  const [FacilityList, setFacilityList] = useState(getFacilityListByGroup(RoleItemGroupId));
  const isFacilityIdFound = FacilityList.some(facility => facility.id == FacilityId);
  const [currFacilityId, setCurrFacilityId] = useState(isFacilityIdFound ? FacilityId : "");

  const handleProductGroupChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setCurrProductGroupId(rowId);

    const newFacilityList = getFacilityListByGroup(rowId);
    setFacilityList(newFacilityList);
    
    const isFacilityIdFound = newFacilityList.some(facility => facility.id == DefaultFacilityId);
    setCurrFacilityId(isFacilityIdFound ? DefaultFacilityId : "");

  };


  const handleFacilityChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }
    
     setCurrFacilityId(rowId);
     let params2={action:"gUserListByFacility","menukey": menukey, "FacilityId":rowId};
     mutategUserListByFacility(params2);

  };

  const {  mutate:mutategUserListByFacility } = useMutation(api.gUserListByFacility, {
    onSuccess: (data) => { 
      if (data.status == 200) {  
        
        localStorage.setItem(
          "UsersListByFacility",
          JSON.stringify(data.data.datalist)
        );
  
      }
    }
  })

  React.useEffect(() => {
    localStorage.setItem(
      "FacilityId",
      currFacilityId
    );
  
   }, [currFacilityId]);


  const [selectedStartDate, setSelectedStartDate] = React.useState(
    format(subDays(new Date(), 90), 'yyyy-MM-dd')
  );

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
    setLoading(true);
  };

  const [selectedEndDate, setSelectedEndDate] = React.useState(
    format(new Date(), 'yyyy-MM-dd')
  );

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
    setLoading(true);
  };

  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();

  const [isLoading, setLoading] = useState(true);

  let params = {
    menukey: menukey,
    FacilityId: currFacilityId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    StartDate: selectedStartDate,
    EndDate: selectedEndDate,
    TransactionTypeId: 4,
    ItemGroupId: currProductGroupId,
  };
  const { error, isError, data, refetch } = useQuery(
    [params],
    api.getDispenseInvs,
    {
      onSuccess: (data) => {
        //console.log("ddddddddd");
        setDataItems(data);
        setLoading(false);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );

  const { mutate } = useMutation(api.deleteDispenseInv, {
    onSuccess: (data) => {
      if (data.status == 200) {
        refetch();

        queryClient.getQueriesData("dispense");

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
          duration: 10000,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let StartDate = format(new Date(selectedStartDate), 'yyyy-MM-dd');
    let EndDate = format(new Date(selectedEndDate), 'yyyy-MM-dd');
    let currFacilityName=(FacilityList.find(Facility_List => Facility_List.id == currFacilityId) ?? null).name;


    window.open(
      finalUrl +
        "?action=getDispense" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&FacilityId=" +
        currFacilityId +
        "&FacilityName=" +
        currFacilityName +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate +
        "&ItemGroupId=" +
        currProductGroupId +
        /* "&ItemGroupName=" +
        ProductGroupList[currProductGroupId] + */
        "&TimeStamp=" +
        Date.now()
    );
  };
  /* =====End of Excel Export Code==== */

  const tableRowDoubleClick = (e: any, row: any) => {
    let rowData = row._row.data;
    editReceiveInv(rowData);
  };

  const columns = [
    { title: "Id", field: "id", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      hozAlign: "center",
      width: 70,
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Dispense Date"]),
      width: 150,
      field: "TransactionDate",
      headerFilter: true,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == null ? "" : format(new Date(value), 'dd/MM/yyyy');
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Dispense Invoice No"]),
      field: "TransactionNo",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Amount"]),
      field: "Amount",
      width: "10%",
      formatter: "money",
      hozAlign: "right",
      headerHozAlign: "right",
      bottomCalc: "sum",
      headerFilter: true,
      bottomCalcFormatter: "money",
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Prepared By"]),
      field: "PreparedBy",
      headerFilter: true,
      width: 170,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Approved By"]),
      field: "ApprovedBy",
      headerFilter: true,
      width: 170,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Status"]),
      width: 85,
      field: "bStockUpdated",
      hozAlign: "center",
      vertAlign: "middle",
      formatter: "tickCross",
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      headerSort: false,
      hozAlign: "center",
      headerHozAlign: "center",
      width: 100,
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const handleChangePage = (data) => {
    setPageNumber(data);
    setFirstLoad(false);
  };
  const handleChangeRowPerPage = (data) => {
    setNumberRowPerPage(data);
  };

  const editReceiveInv = (data) => {
    let route = `/dispense/edit/${data.id}`;
    props.history.push(route);
  };

  const deleteDispenseInv = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this Dispense Invoice!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        mutate(data.id);
      }
    });
  };

  function ActionButton(props) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";

    if (rowData.bStockUpdated || permissionType)
      return (
        <>
          <ViewList
            onClick={() => {
              editReceiveInv(rowData);
            }}
          />
        </>
      );
    else
      return (
        <>
          <Edit
            onClick={() => {
              editReceiveInv(rowData);
            }}
          />
          <DeleteOutline
            onClick={() => {
              deleteDispenseInv(rowData);
            }}
          />
        </>
      );
  }

  const addOrder = (OrderProductData) => {
    editReceiveInv(OrderProductData);

    //setManyTableData(OrderProductData.concat(ManyTableData));
    // handleAdd(OrderProductData.concat(ManyTableData));
    // handleClose('OrderModal');
  };

  /*   const handleModal = (modalname) => {
    switch (modalname) {
      case "OrderModal":
        setOpenOrder(false);
        break;
      case "OrderOpen":
        setOpenOrder(true);
        break;
      default:
        break;
    }
  }; */

  useEffect(() => {
    refetch();
  }, [selectedEndDate, selectedEndDate]);

  return (
    <>
      <div className={classes.ReceivePageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Dispense"]}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={2}>
              <Grid item xs={2} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                  <Grid container justifyContent="space-around">
                    <DatePicker
                      inputFormat="dd/MM/yyyy"
                      label={DispensingLanguage[lan][menukey]["From"]}
                      value={selectedStartDate}
                      onChange={handleStartDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.fullWidth}
                          id="date-picker-inline"
                        />
                      )}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>

              <Grid item xs={2} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                  <Grid container justifyContent="space-around">
                    <DatePicker
                      inputFormat="dd/MM/yyyy"
                      label={DispensingLanguage[lan][menukey]["To"]}
                      value={selectedEndDate}
                      onChange={handleEndDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.fullWidth}
                          id="date-picker-inline"
                        />
                      )}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>

              <Grid item xs={2} sm={2}>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    className="sw_chosen_filter"
                    id="ProductGroupList"
                    disableClearable
                    //disabled={userId == 1 ? false : true}
                    disabled={prodGroupCountUnderRole > 1 ? false : true}
                    options={ProductGroupList}
                    onChange={(event, newValue) =>
                      handleProductGroupChange(event, newValue)
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                    value={
                      (ProductGroupList.find(
                          (productGroupList) =>
                            productGroupList.id == currProductGroupId
                        ) ?? null)
                    }
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          DispensingLanguage[lan][menukey]["Product Group"]
                        }
                        variant="standard"
                        hiddenLabel
                      />
                    )}
                  />
                </FormControl>
              </Grid>


              <Grid item xs={3} sm={3}>
                <FormControl className={classes.fullWidth}> 
                <Autocomplete
                      autoHighlight
                      className="sw_chosen_filter"
                      id="FacilityList"
                      disableClearable
                      disabled={IsAllFacility == 1 ? false : true}
                      options={FacilityList}
                      value={FacilityList.find((facility) => facility.id == currFacilityId) || null}
                      onChange={(event, newValue) => handleFacilityChange(event, newValue)}
                      getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id ?? option.name}>
                          <Typography className="sw_fontSize">{option.name}</Typography>
                        </li>
                      )}
                      
                      renderInput={(params) => (
                      <TextField
                        {...params}
                          label={DispensingLanguage[lan][menukey]["Facility"]}
                        variant="standard"
                        hiddenLabel
                      />
                      )}
                    />

                </FormControl>
              </Grid> 

              <Grid item xs={3} sm={3}>
                <div className="float-end sw_btn_control">
                  {/*       <Button
                    color="info"
                    className="me-2"
                    onClick={() => handleModal("OrderOpen")}
                  >
                    {DispensingLanguage[lan][menukey]["Select From Order"]}
                  </Button> */}
                  <Button
                    color="info"
                    className="me-2"
                    disabled={!!(currProductGroupId == 3 || permissionType || !currFacilityId)}
                    onClick={() => {
                      props.history.push("/dispense/add/" + currProductGroupId);
                    }}
                  >
                    {DispensingLanguage[lan][menukey]["Add Dispense"]}
                  </Button>

                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("print")}
                  >
                    <i className="fas fa-print"></i>
                  </Button>

                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("excel")}
                  >
                    <i className="far fa-file-excel"></i>
                  </Button>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        {/*  <OrderModal
          handleClose={handleModal}
          openOrder={openOrder}
          addOrder={addOrder}
          ItemGroupId={currProductGroupId}
          {...props}
        /> */}
        <div className="sw_relative">
          {isLoading && <LoadingSpinnerOpaque />}
          <div className="uniqueName">
            <ReactTabulator
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              height="450px"
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceiveInv;

const useStyles = makeStyles({
  ReceivePageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
